// extracted by mini-css-extract-plugin
module.exports = {"content":"QSREditOrder_content__c87J7","loading":"QSREditOrder_loading__OnoIc"};